// biome-ignore lint/correctness/noUnusedVariables:
let tagsWithGroups = null

function getUpdatedIntegrations(partners) {
    const idMap = getIntegrationsIdMap(partners)
    for (const key in idMap) {
        const partnerData = idMap[key]
        partnerData.partnerImage = partnerData.ImageURLSVG || partnerData.ImageURL
        partnerData.categories = partnerData.Tags?.split(',').map((x) => x.trim())
    }

    return idMap
}

function getIntegrationsIdMap(json) {
    const idMap = {}
    if (json?.Partners) {
        json.Partners.forEach((partner) => {
            if (partner.Id) {
                idMap[partner.Id] = partner
            }
            if (partner.DisplayName) {
                idMap[partner.DisplayName] = partner
            }
        })
    }
    if (json.TagsWithGroups) {
        tagsWithGroups = json.TagsWithGroups
    }
    return idMap
}

module.exports = {
    getUpdatedIntegrations,
    getIntegrationsIdMap,
}
